module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.open
    }
  }, [_c('a', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "auto",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "icon-shield icon text-danger"
  }), _vm._v(" "), _c('span', [_vm._v("Polícia Civil")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-sub dk"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'roubo-furto.list'
      }
    }
  }, [_c('span', [_vm._v("Roubo/Furto")])])], 1), _vm._v(" "), (_vm.podeAcessarApreensao311) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'grv',
        query: {
          tipoGrv: _vm.GRV_APREENSAO_311
        }
      }
    }
  }, [_c('span', [_vm._v("Apreensão 311")])])], 1) : _vm._e(), _vm._v(" "), (_vm.podeAcessarMenusConfiguracao) ? _c('Diarias') : _vm._e(), _vm._v(" "), (_vm.podeAcessarMenusConfiguracao) ? _c('Policiais') : _vm._e(), _vm._v(" "), (_vm.podeAcessarMenusConfiguracao) ? _c('Notificacao') : _vm._e(), _vm._v(" "), (_vm.podeAcessarMenusConfiguracao) ? _c('Processo') : _vm._e(), _vm._v(" "), (_vm.podeAcessarMenusConfiguracao) ? _c('Sistema') : _vm._e(), _vm._v(" "), (_vm.podeAcessarMenusConfiguracao) ? _c('Veiculo') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right text-muted"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-right text"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-fw fa-angle-down text-active"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-sub-header"
  }, [_c('a', [_c('span', {
    staticClass: "text-muted teste"
  }, [_vm._v("Polícia Civil")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43d13910","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/menu/PoliciaCivil.vue
// module id = 1821
// module chunks = 18